import { Modal } from '@bigcommerce/big-design';

export function TagRemoveWarning({ onCancel, onComplete }) {
	return (
		<Modal
			header={'Are you sure you want to remove this tag?'}
			isOpen={true}
			closeOnClickOutside={true}
			onClose={onCancel}
			actions={[
				{ text: 'No', variant: 'secondary', onClick: onCancel },
				{
					text: 'Yes',
					variant: 'primary',
					onClick: () => onComplete(),
				},
			]}
		></Modal>
	);
}
